import { UserService } from './../../../service/user.service';
import { Component, computed, inject, input, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, Renderer2, Inject, HostBinding } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription, forkJoin } from 'rxjs';
import { TeamImaginusNavService, TeamHeaderAction } from '../../../service/team-imaginus-nav.service';
import { ChatConversationService } from '../../../service/chat-conversation.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from '../../../service/auth.service';
import { ApplicationSessionStateService } from '../../../service/application-session-state.service';
import { clearLocalStorageSession } from '../../../service/local-storage-session.util';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from './../../../../environments/environment'
import { MailboxService } from './../../../service/mailbox.service';
import { GroupService } from './../../../service/group.service';
// 引入 TeamService
import { TeamService } from '../../../service/team.service';
import { team, enterprise } from './../../../shared/shared.module'
import {
  ColorModeService,
  ContainerComponent,
  DropdownComponent,
  DropdownItemDirective,
  DropdownMenuDirective,
  DropdownToggleDirective,
  HeaderComponent,
  HeaderNavComponent,
  HeaderTogglerDirective,
  ThemeDirective,
  TableModule,
  GridModule,
  NavModule,
  // 補上 Modal 及 Button 等必要元件
  ModalComponent,
  ModalHeaderComponent,
  ModalTitleDirective,
  ModalBodyComponent,
  ModalFooterComponent,
  ButtonCloseDirective,
  ButtonDirective,
  FormControlDirective,
  FormLabelDirective,
  SpinnerComponent
} from '@coreui/angular';
import { IconDirective } from '@coreui/icons-angular';
import { AppNavBackComponent } from '../../../shared/app-nav-back/app-nav-back.component';
import { HelpArticleLinkComponent } from '../../../shared/help-article-link.component';
import { HELP_ARTICLES } from '../../../shared/help-article-ids';
import { SidebarStateService } from '../../../service/sidebar-state.service';
import { TranslateModule } from '@ngx-translate/core';
import { LocaleService } from '../../../service/locale.service';
import { TokenStorageService } from '@services/token-storage.service';

interface User {
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  profile_picture?: string;
  notification_method: string[];
  role: string[];
}

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
  standalone: true,
  imports: [
    FormsModule, CommonModule, ReactiveFormsModule, TableModule, GridModule, NavModule,
    ContainerComponent, HeaderNavComponent, HeaderTogglerDirective, IconDirective,
    RouterLink, ThemeDirective,
    DropdownComponent, DropdownToggleDirective, DropdownMenuDirective, DropdownItemDirective,
    // 註冊 Modal 與表單元件
    ModalComponent, ModalHeaderComponent, ModalTitleDirective, ModalBodyComponent, ModalFooterComponent,
    ButtonCloseDirective, ButtonDirective, FormControlDirective, FormLabelDirective, SpinnerComponent,
    AppNavBackComponent,
    HelpArticleLinkComponent,
    TranslateModule,
  ]
})
export class DefaultHeaderComponent extends HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly help = HELP_ARTICLES;
  public profile_picture = '';
  public userRoles: string[] = [];
  isMailboxOpen = false;
  hasUnreadMail: boolean = false;
  isSettingOpen = false;
  isSettingModalVisible: boolean = false;
  previewImage: string | null = null;
  showConfirmDialog = false;
  originalFormValue: any;
  selectedFile: File | null = null;
  formData!: FormGroup;
  production = environment.production;
  apiBaseUrl = environment.apiBaseUrl;
  filetooLarge = false;
  filenotJPG = false;
  visible = false;
  private mailSubscription!: Subscription;

  // --- 創建團隊 Modal 狀態 ---
  isCreateTeamModalVisible: boolean = false;
  newTeamName: string = '';
  isCreatingTeam: boolean = false;

  showImaginusToolbar = false;

  @HostBinding('class.app-header--floating')
  get floatingHeader(): boolean {
    // 所有系統內頁面都採用 imaginus 式浮動頂欄（左右控件浮空、不佔版面），
    // 不再於非對話頁渲染一條空的佔位橫幅。
    return true;
  }
  activeSessionTitle: string | null = null;
  activeSessionSubtitle: string | null = null;
  activeSessionActions: TeamHeaderAction[] = [];
  userMenuOpen = false;
  readonly userMenuPopperOptions = {
    placement: 'bottom-end' as const,
    strategy: 'fixed' as const,
    modifiers: [
      { name: 'offset', options: { offset: [0, 8] } },
      { name: 'preventOverflow', options: { padding: 8, boundary: 'viewport' as const } },
    ],
  };
  private imaginusRouteSub?: Subscription;
  private imaginusTitleSub?: Subscription;
  private imaginusSubtitleSub?: Subscription;
  private imaginusActionsSub?: Subscription;
  private avatarSub?: Subscription;

  @ViewChild('modalTeleportTarget', { static: false }) modalTeleportTarget!: ElementRef;
  user: User = {
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    profile_picture: undefined,
    notification_method: [],
    role: []
  };
  enterprise_list: enterprise[] = [];
  team_list: team[] = [];
  activeRouteTeamCode = '';

  readonly #colorModeService = inject(ColorModeService);
  private readonly locale = inject(LocaleService);
  readonly colorMode = this.#colorModeService.colorMode;

  readonly colorModes = [
    { name: 'light', text: 'Light', icon: 'cilSun' },
    { name: 'dark', text: 'Dark', icon: 'cilMoon' },
    { name: 'auto', text: 'Auto', icon: 'cilContrast' }
  ];

  readonly icons = computed(() => {
    const currentMode = this.colorMode();
    return this.colorModes.find(mode => mode.name === currentMode)?.icon ?? 'cilSun';
  });

  constructor(
    private authService: AuthService,
    private applicationSessionState: ApplicationSessionStateService,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    private MailboxService: MailboxService,
    private groupService: GroupService,
    private teamService: TeamService,
    private teamImaginusNav: TeamImaginusNavService,
    private sidebarState: SidebarStateService,
    private renderer: Renderer2,
    public chatConversationService: ChatConversationService,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
    this.get_self_info();
    this.getUserRoles();
  }
  ngAfterViewInit(): void {
    if (this.modalTeleportTarget?.nativeElement) {
      this.renderer.appendChild(this.document.body, this.modalTeleportTarget.nativeElement);
    }
  }

  ngOnInit(): void {
    this.profile_picture = this.defaultAvatarUrl;
    this.refreshPersonalAvatar();
    this.refreshImaginusToolbarVisibility();
    this.imaginusTitleSub = this.teamImaginusNav.activeSessionTitle$.subscribe((t) => {
      this.activeSessionTitle = t;
      this.refreshImaginusToolbarVisibility();
    });
    this.imaginusSubtitleSub = this.teamImaginusNav.activeSessionSubtitle$.subscribe((s) => {
      this.activeSessionSubtitle = s;
    });
    this.imaginusActionsSub = this.teamImaginusNav.activeSessionActions$.subscribe((a) => {
      this.activeSessionActions = a || [];
    });
    this.imaginusRouteSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        this.refreshImaginusToolbarVisibility();
        this.syncActiveRouteTeamCode();
      });

    this.mailSubscription = this.MailboxService.unreadMail$.subscribe((status) => {
      this.hasUnreadMail = status;
    });

    this.groupService.get_user_enterprise().subscribe(
      (data) => {
        TokenStorageService.refreshToken(data.token);
        for (let enterprise of data.enterprises){
          this.enterprise_list.push({
            taxId: enterprise.taxId,
            name: enterprise.name,
            address: enterprise.address,
            telephone: enterprise.telephone
          });
        }
      },
      (error) => console.error('Error fetching user enterprises:', error)
    );

    // 載入團隊清單
    this.loadTeamList();
    this.syncActiveRouteTeamCode();
  }

  ngOnDestroy(): void {
    this.avatarSub?.unsubscribe();
    this.imaginusRouteSub?.unsubscribe();
    this.imaginusTitleSub?.unsubscribe();
    this.imaginusSubtitleSub?.unsubscribe();
    this.imaginusActionsSub?.unsubscribe();
    if (this.mailSubscription) {
      this.mailSubscription.unsubscribe();
    }

    if (this.modalTeleportTarget && this.modalTeleportTarget.nativeElement) {
      this.renderer.removeChild(this.document.body, this.modalTeleportTarget.nativeElement);
    }
  }

  // 將獲取團隊清單抽離成獨立方法，方便後續呼叫
  loadTeamList() {
    this.team_list = [];
    this.groupService.get_user_team().subscribe(
      (data) => {
        TokenStorageService.refreshToken(data.token);
        for (let team of data.teams) {
          this.team_list.push({
            team_name: team.team_name,
            team_code: team.team_code,
            disabled: !!team.disabled,
            accounts: []
          });
        }
        this.syncUnifiedUnreadMail();
      },
      (error) => console.error('Error fetching user teams:', error)
    );
  }

  // --- 創建團隊相關邏輯 ---
  openCreateTeamModal() {
    this.newTeamName = '';
    this.userMenuOpen = false;
    this.isCreateTeamModalVisible = true;
  }

  closeCreateTeamModal() {
    this.isCreateTeamModalVisible = false;
    this.newTeamName = '';
  }

  submitCreateTeam() {
    if (!this.newTeamName.trim()) return;
    this.isCreatingTeam = true;

    this.groupService.create_team(this.newTeamName).subscribe({
      next: (response) => {
        if (response && response.token) {
          TokenStorageService.refreshToken(response.token);
        }
        // 成功建立後，刷新清單並關閉彈窗
        this.loadTeamList();
        this.isCreatingTeam = false;
        this.closeCreateTeamModal();
      },
      error: (error) => {
        console.error('創建團隊失敗:', error);
        this.isCreatingTeam = false;
        // 在這裡可以加上 alert 或 toast 通知使用者錯誤
      }
    });
  }

  // ... 保持原本的其他程式碼 ...

  get_self_info() {
    this.userService.get_self_info().subscribe(
      (data) => {
        if (!data?.user) {
          return;
        }
        this.user = data.user;
        if (data.user?.email) {
          this.chatConversationService.setCurrentEmail(data.user.email);
          this.chatConversationService.refreshConversations();
        }
        TokenStorageService.refreshToken(data.token);
        this.refreshPersonalAvatar(true);
      },
      (error) => {}
    );
  }

  getUserRoles() {
    this.userService.getUserRoles().subscribe(
      (data) => {
        this.userRoles = data.roles;
        TokenStorageService.refreshToken(data.token);
      },
      (error) => {
        this.userRoles = [];
      }
    );
  }

  onlogout() {
    this.userMenuOpen = false;
    this.applicationSessionState.resetForLogout();
    clearLocalStorageSession();
    this.authService.logout();
    this.router.navigate(['/sign-in']);
  }

  sidebarId = input('sidebar1');

  get defaultAvatarUrl(): string {
    return this.userService.defaultAvatarUrl;
  }

  syncUnifiedUnreadMail(): void {
    const teamCodes = this.team_list.filter((t) => !t.disabled).map((t) => t.team_code);
    const requests = [
      this.MailboxService.loadMails(),
      ...teamCodes.map((code) => this.MailboxService.loadTeamMails(code)),
    ];
    forkJoin(requests).subscribe({
      next: (results) => {
        results.forEach((data: { token?: string }) => {
          if (data?.token) {
            TokenStorageService.refreshToken(data.token);
          }
        });
        const hasUnread = results.some((data) => this.MailboxService.hasUnreadInMailList(data));
        this.hasUnreadMail = hasUnread;
        this.MailboxService.updateUnreadMailStatus(hasUnread);
      },
    });
  }

  OpenMailbox(): void {
    this.userMenuOpen = false;
    const queryParams: Record<string, string> = {};
    if (this.activeRouteTeamCode) {
      queryParams['team'] = this.activeRouteTeamCode;
    }
    this.router.navigate(['/mailbox'], { queryParams });
  }

  /** 統一聊天收件匣入口所用的 team_code：優先取當前路由團隊，否則取第一個團隊。 */
  get chatTeamCode(): string {
    return this.activeRouteTeamCode || this.team_list[0]?.team_code || '';
  }

  /** 聊天室/私訊是否有未讀（含場域聊天室與私訊）。 */
  get hasChatUnread(): boolean {
    return this.chatConversationService.hasAnyUnread();
  }

  private syncActiveRouteTeamCode(): void {
    let path = this.router.url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    const match = path.match(/^\/team\/([^/]+)/);
    this.activeRouteTeamCode = match?.[1] || '';
  }

  refreshPersonalAvatar(force = false): void {
    this.avatarSub?.unsubscribe();
    this.avatarSub = this.userService.loadPersonalAvatarUrl(force).subscribe({
      next: (url) => {
        this.profile_picture = url || this.defaultAvatarUrl;
      },
      error: () => {
        this.profile_picture = this.defaultAvatarUrl;
      },
    });
  }

  onAvatarImageError(): void {
    this.profile_picture = this.defaultAvatarUrl;
  }

  getUserAvatar(){
    this.refreshPersonalAvatar(true);
  }

  toggleLiveDemo() {
    this.visible = !this.visible;
  }

  cancelSave(): void {
    if(this.formData) {
       this.formData.patchValue(this.originalFormValue);
       this.formData.markAsPristine();
    }
    this.visible = false;
    this.isSettingModalVisible = true
    if (this.previewImage) {
      this.previewImage = null;
    }
  }

  get headerSidebarToggleLabel(): string {
    return this.locale.instant('layout.header.openMenu');
  }

  onHeaderSidebarToggle(): void {
    this.sidebarState.requestSidebarToggle('individual');
  }

  navigateToIdentity(type: 'user' | 'enterprise' | 'team', id: string) {
    this.userMenuOpen = false;
    if (type === 'user') {
      this.router.navigate(['/home']);
    } else if (type === 'enterprise') {
      this.router.navigate(['/enterprise', id, 'home']);
    } else if (type === 'team') {
      const t = this.team_list.find((x) => x.team_code === id);
      if (t?.disabled) {
        alert(this.locale.instant('layout.header.teamDisabled'));
        return;
      }
      this.router.navigate(['/team', id, 'home']);
    }
  }

  private refreshImaginusToolbarVisibility(): void {
    let path = this.router.url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    const isImaginusRoute = path === '/home' || path === '/imaginus';
    const onTeamHome = /^\/team\/[^/]+\/home$/i.test(path);
    // 場域聊天室（App1 / App2）也把場域名稱顯示在中央 header 標題列
    const onChatroom = /^\/team\/[^/]+\/application\/[12]\/places\/[^/]+\/chatroom$/i.test(path);
    // 統一聊天收件匣：把場域名稱／私訊對象名稱顯示在中央 header 標題列
    const onChats = /^\/team\/[^/]+\/chats/i.test(path);
    this.showImaginusToolbar = isImaginusRoute || onTeamHome || onChatroom || onChats;
  }

  /** 頂欄是否顯示「上一層」；新對話（/home、/imaginus 且無標題）為唯一不顯示的情境 */
  get showHeaderNavBack(): boolean {
    if (!this.showImaginusToolbar) {
      return true;
    }
    let path = this.router.url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    const isImaginusRoute = path === '/home' || path === '/imaginus';
    if (isImaginusRoute && !this.imaginusHeaderTitle) {
      return false;
    }
    return true;
  }

  /** 新對話／預設名稱頂欄留空，不顯示「新對話」佔位字 */
  get imaginusHeaderTitle(): string {
    const t = (this.activeSessionTitle || '').trim();
    if (!t) {
      return '';
    }
    if (t === '新對話' || t === '新交談') {
      return '';
    }
    const newDefault = this.locale.instant('layout.chat.newChatDefault');
    const newAlt = this.locale.instant('layout.chat.newChatAlt');
    if (t === newDefault || t === newAlt) {
      return '';
    }
    return t;
  }

  /** 觸發 header 上自訂動作鈕 */
  onHeaderActionClick(action: TeamHeaderAction, event: Event): void {
    event.stopPropagation();
    try {
      action?.onClick?.();
    } catch {
      /* swallow */
    }
  }

  trackByHeaderActionId(_: number, action: TeamHeaderAction): string {
    return action?.id ?? String(_);
  }

  /** 中央 header 主要動作 label：用於可點擊的 titlebox aria-label */
  get primaryHeaderActionLabel(): string {
    const first = this.activeSessionActions?.[0];
    return first?.ariaLabel || first?.title || first?.label || this.locale.instant('layout.header.viewDetails');
  }

  /** 點擊 header 標題區（Line 風格）：觸發第一個動作 */
  onPrimaryHeaderClick(event: Event): void {
    const first = this.activeSessionActions?.[0];
    if (!first) return;
    event.stopPropagation();
    try {
      first.onClick?.();
    } catch {
      /* swallow */
    }
  }

  get imaHomeQueryParams(): { new?: string } {
    let path = this.router.url.split('?')[0];
    if (path.includes('#')) {
      path = path.split('#').pop() || path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    return path === '/home' || path === '/imaginus' ? { new: '1' } : {};
  }
}
